<script>
const GUIDES = {
  operations: {
    heading: '상품 운영 현황에서 하는 일',
    description: '상품 관리 업무의 현재 상태를 빠르게 확인하고, 처리할 화면으로 이동합니다.',
    cards: [
      { icon: 'pending_actions', title: '승인 대기', copy: '파트너가 등록한 요청 중 아직 검토하지 않은 건수입니다.' },
      { icon: 'link', title: '연결 검토 필요', copy: '기존 기준 상품과 연결 여부를 확인해야 하는 항목입니다.' },
      { icon: 'history', title: '장기 미처리 요청', copy: '오래 대기 중인 요청을 우선 처리할 수 있도록 보여줍니다.' },
    ],
    steps: [
      { title: '상단 요약 카드를 확인합니다.', copy: '승인 대기, 연결 검토 필요, 정상 연결, 미연결 상품 건수를 먼저 확인하세요.' },
      { title: '우선 처리할 목록을 확인합니다.', copy: '전체 요청 대기 목록과 장기 미처리 요청을 기준으로 작업 순서를 정합니다.' },
      { title: '바로가기 아이콘으로 이동합니다.', copy: '각 카드와 목록의 우측 아이콘을 누르면 조건에 맞는 관리 화면으로 이동합니다.' },
      { title: '필요하면 새로고침합니다.', copy: '타이틀 우측 새로고침 아이콘으로 최신 현황을 다시 불러옵니다.' },
    ],
    note: '상품 운영 현황은 상태를 확인하는 화면입니다. 실제 승인과 연결 작업은 요청/매핑 관리에서 진행하세요.'
  },
  requestMappings: {
    heading: '요청/매핑 관리에서 하는 일',
    description: '파트너 상품 요청을 검토하고, 파트너 SKU와 기준 상품의 연결 상태를 관리합니다.',
    cards: [
      { icon: 'hourglass_top', title: '요청 · 대기', copy: '새로 들어온 연결요청 또는 신규등록요청을 확인하고 처리합니다.' },
      { icon: 'link', title: '매핑 · 연결 검토', copy: '기존 기준 상품과 연결할 수 있는 항목을 확인합니다.' },
      { icon: 'task_alt', title: '매핑 · 정상 연결', copy: '파트너 SKU와 기준 상품의 연결이 완료된 항목입니다.' },
    ],
    steps: [
      { title: '업무에 맞는 탭을 선택합니다.', copy: '요청 탭 2개는 요청 처리, 매핑 탭 2개는 연결 상태 확인에 사용합니다.' },
      { title: '파트너 또는 SKU를 검색합니다.', copy: '파트너명, 파트너 SKU, 브랜드 또는 상품명으로 필요한 항목을 찾습니다.' },
      { title: '행을 선택해 상세 화면으로 이동합니다.', copy: '요청 상세에서 기존 상품 연결 승인, 신규 상품 생성 승인 또는 반려를 처리합니다.' },
      { title: '처리 후 상태를 다시 확인합니다.', copy: '처리가 완료되면 정상 연결 탭에서 결과를 확인할 수 있습니다.' },
    ],
    note: '연결요청은 기존 기준 상품이 있는 경우입니다. 신규등록요청은 같은 기준 상품이 없어 새 상품 생성 검토가 필요한 경우입니다.',
    glossary: [
      { term: '요청 · 대기', description: '새로 들어와 아직 처리하지 않은 요청' },
      { term: '요청 · 반려', description: '정보 보완 후 다시 요청해야 하는 항목' },
      { term: '매핑 · 연결 검토', description: '기존 기준 상품과 연결 여부를 확인하는 항목' },
      { term: '매핑 · 정상 연결', description: '파트너 SKU와 기준 상품의 연결이 완료된 항목' },
    ]
  },
  masterSkuList: {
    heading: '목록 조회에서 하는 일',
    description: '등록된 기준 상품을 검색하고 파트너 SKU 연결 현황을 확인합니다.',
    cards: [
      { icon: 'search', title: '상품 검색', copy: '상품명, 마스터 SKU, 브랜드를 기준으로 빠르게 검색합니다.' },
      { icon: 'filter_alt', title: '상태 필터', copy: '정상 연결, 미연결, 비활성 상품을 한 번에 구분합니다.' },
      { icon: 'open_in_new', title: '상세 확인', copy: '행 또는 상세보기 아이콘을 눌러 상품 정보와 연결 상태를 확인합니다.' },
    ],
    steps: [
      { title: '검색어 또는 빠른 필터를 선택합니다.', copy: '전체, 정상 연결, 미연결, 비활성 중 필요한 조건을 선택하세요.' },
      { title: '필요하면 상세 조건을 추가합니다.', copy: '브랜드, 카테고리, HS CODE, 규격 타입, 활성 여부를 함께 설정할 수 있습니다.' },
      { title: '조회 결과와 연결 상태를 확인합니다.', copy: '연결 SKU 수와 연결 파트너를 확인해 상품 사용 현황을 파악합니다.' },
      { title: '상세 화면으로 이동합니다.', copy: '상품 정보 수정이나 연결 현황 확인이 필요하면 행 또는 우측 아이콘을 누릅니다.' },
    ],
    note: '새 상품을 등록하기 전에 목록 조회에서 동일한 기준 상품이 이미 있는지 먼저 확인하세요.'
  },
  packingExpressRules: {
    heading: '익스프레스 규칙 관리에서 하는 일',
    description: '포장 화면의 익스프레스 모드를 사용할 수 있는 파트너와 상품 범위를 관리합니다.',
    cards: [
      { icon: 'local_shipping', title: '파트너 범위', copy: 'FULFILLMENT 계약 파트너를 기준으로 허용 규칙을 등록합니다.' },
      { icon: 'filter_alt', title: '상품 범위', copy: '브랜드와 카테고리를 조합해 허용 상품을 제한합니다. 익스프레스는 주문 전체가 상품 한 행, 수량 1개인 경우에만 적용하며 나머지 주문은 일반 포장으로 진행합니다.' },
      { icon: 'toggle_on', title: '활성 상태', copy: '규칙을 삭제하지 않고 비활성화해 운영 이력을 유지합니다.' },
    ],
    steps: [
      { title: '파트너를 선택합니다.', copy: '익스프레스 포장을 허용할 FULFILLMENT 계약 파트너를 선택하세요.' },
      { title: '브랜드와 카테고리 범위를 정합니다.', copy: '비운 항목은 전체를 뜻합니다. 두 항목을 모두 비우면 파트너 전체 상품이 대상입니다.' },
      { title: '운영 메모를 남깁니다.', copy: '허용 사유나 적용 범위를 다른 운영자가 이해할 수 있게 기록하세요.' },
      { title: '활성화 후 포장 화면에서 확인합니다.', copy: '실제 대상 상품에서 익스프레스 모드가 노출되는지 확인하세요.' },
    ],
    note: '브랜드와 카테고리를 모두 비운 활성 규칙은 범위가 매우 넓습니다. 세부 규칙과 동시에 활성화할 수 없으며, 반드시 의도한 파트너인지 확인하세요.',
    glossary: [
      { term: '전체 브랜드', description: '선택한 카테고리 안에서 브랜드를 제한하지 않습니다.' },
      { term: '전체 카테고리', description: '선택한 브랜드 안에서 카테고리를 제한하지 않습니다.' },
      { term: '파트너 전체 상품', description: '브랜드와 카테고리를 모두 비운 규칙입니다.' },
    ]
  },
  masterData: {
    heading: '브랜드/카테고리 관리에서 하는 일',
    description: '상품 등록에 사용하는 브랜드와 카테고리 이름을 추가하고 정리합니다.',
    cards: [
      { icon: 'sell', title: '브랜드 관리', copy: '브랜드명을 등록하고 잘못 입력된 이름을 수정합니다.' },
      { icon: 'category', title: '카테고리 관리', copy: '카테고리명과 기본 규격 타입을 함께 관리합니다.' },
      { icon: 'toggle_on', title: '활성 상태 관리', copy: '더 이상 사용하지 않는 항목은 비활성화해 선택 목록에서 구분합니다.' },
    ],
    steps: [
      { title: '브랜드 또는 카테고리 탭을 선택합니다.', copy: '관리하려는 기준정보 종류에 맞는 탭으로 이동하세요.' },
      { title: '검색과 활성 여부 필터로 항목을 찾습니다.', copy: '이름이 유사한 항목이나 비활성 항목을 빠르게 확인할 수 있습니다.' },
      { title: '타이틀 우측 등록 버튼으로 새 항목을 추가합니다.', copy: '현재 탭에 따라 브랜드 등록 또는 카테고리 등록 팝업이 열립니다.' },
      { title: '목록의 수정 버튼으로 기존 항목을 정리합니다.', copy: '파트너가 직접 입력한 이름도 관리자가 수정하거나 비활성화할 수 있습니다.' },
    ],
    note: '유사한 이름을 중복 등록하지 마세요. 기존 항목의 오타라면 새로 만들지 말고 수정 기능을 사용하세요.',
    glossaryTitle: '등록·수정 팝업',
    glossary: [
      { term: '브랜드 등록/수정', description: '브랜드명과 활성 여부를 입력합니다.' },
      { term: '카테고리 등록/수정', description: '카테고리명, 기본 규격 타입, 활성 여부를 입력합니다.' },
      { term: '활성 여부', description: '더 이상 사용하지 않는 항목은 비활성으로 변경합니다.' },
      { term: '수정 우선', description: '오타나 표기 차이는 새 항목을 만들기보다 기존 항목을 수정합니다.' },
    ]
  },
  hsCodeManage: {
    heading: 'HS CODE 관리에서 하는 일',
    description: '오더 등록 시 상품명으로 HS CODE가 자동 입력되도록 매칭 기준을 관리합니다.',
    cards: [
      { icon: 'rule', title: '매칭 기준 등록', copy: '상품명과 비교할 exact 또는 keyword 기준과 HS CODE를 등록합니다.' },
      { icon: 'manage_search', title: '매핑 후보 검토', copy: '과거 오더 상품명에서 추출된 대표 키워드 후보와 근거를 확인합니다.' },
      { icon: 'science', title: '매칭 테스트', copy: '상품명을 입력해 실제 자동입력 결과를 미리 확인합니다.' },
      { icon: 'toggle_on', title: '활성 상태 관리', copy: '사용하지 않는 기준은 삭제하지 않고 비활성화해 운영 이력을 보존합니다.' },
    ],
    steps: [
      { title: '매칭방식을 선택합니다.', copy: '정확히 일치는 상품명이 매칭값과 같을 때만 적용되고, 키워드 포함은 상품명 안에 매칭값이 포함되면 적용됩니다.' },
      { title: '매칭값과 HS CODE를 입력합니다.', copy: 'HS CODE는 숫자 6자리로 입력합니다. 매칭값은 운영자가 이해하기 쉬운 단어 또는 상품명으로 등록하세요.' },
      { title: '우선순위를 정합니다.', copy: '여러 키워드가 동시에 걸릴 수 있으므로 더 구체적이고 중요한 기준일수록 낮은 숫자를 사용하세요.' },
      { title: '매핑 후보를 검토합니다.', copy: '후보 탭에서 사용 건수, 원본 종류, 주변 단어 수, 원본 예시 등 추출 근거를 확인합니다.' },
      { title: '필요한 후보를 매핑으로 등록합니다.', copy: '후보의 대표 키워드를 기준으로 HS CODE를 입력하면 실제 자동입력 기준으로 등록됩니다.' },
      { title: '불필요한 후보는 제외합니다.', copy: '컬러나 사이즈처럼 HS CODE 판단에 적합하지 않은 후보는 제외 처리합니다. 제외된 후보는 동일 대표 키워드 기준으로 재추출되지 않습니다.' },
      { title: '잘못 제외한 후보는 제외 해제합니다.', copy: '후보 상태를 제외로 조회한 뒤 제외 해제를 누르면 다시 검토 대기 상태로 복구됩니다.' },
      { title: '상품명 매칭 테스트를 실행합니다.', copy: '등록한 기준이 의도한 HS CODE로 연결되는지 테스트 후 실제 오더 등록에서 확인합니다.' },
      { title: '불필요한 기준은 비활성화합니다.', copy: '잘못된 기준이나 더 이상 쓰지 않는 기준은 비활성화해 자동입력 대상에서 제외합니다.' },
    ],
    note: 'HS CODE는 통관 정보에 영향을 줄 수 있습니다. AI 추정값처럼 불확실한 값은 바로 등록하지 말고, 운영자가 확인한 기준만 활성화하세요.',
    glossaryTitle: '매칭방식 구분',
    glossary: [
      { term: '정확히 일치', description: '상품명이 매칭값과 완전히 같을 때만 적용합니다.' },
      { term: '키워드 포함', description: '상품명에 매칭값이 포함되면 적용합니다.' },
      { term: '우선순위', description: '낮은 숫자가 먼저 적용됩니다. 같은 조건이면 최근 수정 기준을 우선합니다.' },
      { term: '매핑 후보', description: '과거 ITEM 상품명에서 반복 단어와 짧은 구문을 분석해 제안된 검토 대상입니다.' },
      { term: '추출 근거', description: '후보가 생성된 사용 건수, 원본 상품명 종류, 주변 단어 수, 원본 예시입니다.' },
      { term: '제외', description: 'HS CODE 매핑 후보로 부적합한 항목을 다음 추출에서 다시 만들지 않도록 제외하는 상태입니다.' },
      { term: '제외 해제', description: '잘못 제외한 후보를 다시 검토 대기 상태로 되돌리는 기능입니다.' },
      { term: '매칭 테스트', description: '오더 등록 전 어떤 HS CODE가 자동 선택되는지 확인하는 기능입니다.' },
    ]
  },
  requestDetail: {
    heading: '요청 상세에서 하는 일',
    description: '파트너가 등록한 상품 요청을 확인하고 연결 승인, 신규 상품 생성 승인 또는 반려를 처리합니다.',
    cards: [
      { icon: 'description', title: '요청 상품 정보', copy: '파트너, 파트너 SKU, 브랜드, 카테고리, 규격과 요청 유형을 확인합니다.' },
      { icon: 'manage_search', title: '기존 상품 후보', copy: '동일 조건에 가까운 기준 상품 후보를 확인하고 필요한 경우 선택합니다.' },
      { icon: 'task_alt', title: '처리 액션', copy: '권장 처리, 다른 방식 처리, 반려 처리 중 적절한 액션을 실행합니다.' },
    ],
    steps: [
      { title: '요청 유형과 상품 정보를 확인합니다.', copy: '연결요청인지 신규등록요청인지 먼저 확인하고 규격 정보를 검토하세요.' },
      { title: '기존 상품 후보를 확인합니다.', copy: '연결요청은 연결할 후보를 선택합니다. 후보 상세도 추가로 확인할 수 있습니다.' },
      { title: '권장 처리를 우선 검토합니다.', copy: '연결요청은 기존 상품 연결 승인, 신규등록요청은 신규 상품 생성 후 승인이 권장됩니다.' },
      { title: '예외 상황은 다른 방식으로 처리합니다.', copy: '기존 후보가 부적절하거나 적절한 후보를 찾은 경우 다른 방식 처리도 가능합니다.' },
      { title: '정보 보완이 필요하면 반려합니다.', copy: '파트너가 이해할 수 있도록 반려 사유를 구체적으로 입력하세요.' },
    ],
    note: '승인 전 브랜드, 카테고리, HS CODE, 규격 타입과 규격 상세 값을 확인하세요. 승인하면 파트너 SKU 연결 관계가 생성됩니다.',
    glossaryTitle: '처리 방식',
    glossary: [
      { term: '기존 상품 연결 승인', description: '선택한 기준 상품과 파트너 SKU를 연결합니다.' },
      { term: '신규 상품 생성 후 승인', description: '요청 정보로 새 기준 상품을 만들고 연결합니다.' },
      { term: '다른 방식으로 처리', description: '권장 처리와 다른 예외 처리 방식입니다.' },
      { term: '요청 반려', description: '정보 보완이 필요할 때 사유를 입력하고 되돌려 보냅니다.' },
    ]
  },
  masterSkuDetail: {
    heading: '상품 상세에서 하는 일',
    description: '기준 상품의 기본 정보와 연결된 파트너 SKU, 관련 요청을 확인하고 관리합니다.',
    cards: [
      { icon: 'edit', title: '상품 정보 수정', copy: '상품명, 브랜드, 카테고리, HS CODE, 규격, 중량과 활성 상태를 관리합니다.' },
      { icon: 'link', title: '파트너 SKU 연결 현황', copy: '현재 상품에 실제로 연결된 파트너 SKU를 확인하고 필요하면 연결을 해제합니다.' },
      { icon: 'playlist_add_check', title: '관련 요청 현황', copy: '현재 상품과 관련된 요청을 확인하고 바로 연결 승인할 수 있습니다.' },
    ],
    steps: [
      { title: '상단 요약과 기본 정보를 확인합니다.', copy: '마스터 SKU, 연결 상태, 연결된 파트너 SKU 수와 활성 상태를 확인하세요.' },
      { title: '필요한 상품 정보를 수정하고 저장합니다.', copy: '타이틀 우측 저장 버튼을 누르면 변경한 기본 정보와 규격이 반영됩니다.' },
      { title: '연결된 파트너 SKU를 확인합니다.', copy: '연결 해제는 실제 연결 관계를 끊는 작업이므로 대상 SKU를 다시 확인하세요.' },
      { title: '관련 요청을 확인합니다.', copy: '현재 상품으로 연결하는 것이 맞다면 바로 연결 승인을 사용할 수 있습니다.' },
      { title: '목록으로 돌아갑니다.', copy: '타이틀 우측 목록으로 버튼을 누르면 이전 검색 조건을 유지한 채 복귀합니다.' },
    ],
    note: '연결 해제와 바로 연결 승인은 파트너 SKU 관계를 변경합니다. 파트너명과 파트너 SKU 코드를 확인한 뒤 실행하세요.',
    glossaryTitle: '주의가 필요한 액션',
    glossary: [
      { term: '저장', description: '기준 상품의 기본 정보와 규격 변경사항을 반영합니다.' },
      { term: '활성 상태 변경', description: '활성 토글을 변경하면 상태가 즉시 반영됩니다.' },
      { term: '연결 해제', description: '현재 상품과 파트너 SKU의 연결 관계를 끊습니다.' },
      { term: '바로 연결 승인', description: '관련 요청을 현재 상품에 즉시 연결 승인합니다.' },
    ]
  }
}

export default {
  name: 'FulfillmentPageGuide',
  props: {
    guideKey: {
      type: String,
      required: true
    }
  },
  computed: {
    guide() {
      return GUIDES[this.guideKey] || GUIDES.operations
    }
  }
}
</script>

<template>
  <div class="fulfillment-page-guide">
    <div class="guide-heading">{{ guide.heading }}</div>
    <p class="guide-copy">{{ guide.description }}</p>

    <div class="row q-col-gutter-md q-mt-sm">
      <div v-for="card in guide.cards" :key="card.title" class="col-12 col-md-4">
        <div class="guide-card">
          <q-icon :name="card.icon" color="primary" size="24px" />
          <div class="guide-card__title">{{ card.title }}</div>
          <div class="guide-card__copy">{{ card.copy }}</div>
        </div>
      </div>
    </div>

    <div class="guide-subheading">사용 순서</div>
    <ol class="guide-steps">
      <li v-for="(step, index) in guide.steps" :key="step.title">
        <span>{{ index + 1 }}</span>
        <div>
          <b>{{ step.title }}</b>
          <small>{{ step.copy }}</small>
        </div>
      </li>
    </ol>

    <template v-if="guide.glossary">
      <div class="guide-subheading">{{ guide.glossaryTitle || '탭 구분' }}</div>
      <div class="glossary-grid">
        <div v-for="item in guide.glossary" :key="item.term" class="glossary-item">
          <b>{{ item.term }}</b>
          <span>{{ item.description }}</span>
        </div>
      </div>
    </template>

    <q-banner rounded class="guide-warning q-mt-md">
      <template #avatar>
        <q-icon name="info" color="orange-8" />
      </template>
      {{ guide.note }}
    </q-banner>
  </div>
</template>

<style scoped>
.guide-heading {
  color: #183b56;
  font-size: 20px;
  font-weight: 700;
}

.guide-copy {
  margin: 8px 0 0;
  color: #607171;
}

.guide-card {
  height: 100%;
  padding: 16px;
  border: 1px solid #d8e1df;
  border-radius: 12px;
  background: #fff;
}

.guide-card__title,
.guide-subheading {
  color: #183b56;
  font-weight: 700;
}

.guide-card__title {
  margin-top: 10px;
}

.guide-card__copy,
.guide-steps small,
.glossary-item span {
  color: #607171;
  font-size: 13px;
}

.guide-subheading {
  margin-top: 24px;
  font-size: 16px;
}

.guide-steps {
  display: grid;
  gap: 14px;
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.guide-steps li {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.guide-steps li > span {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: #fff;
  background: #1976d2;
  font-size: 12px;
  font-weight: 700;
}

.guide-steps b,
.guide-steps small,
.glossary-item b,
.glossary-item span {
  display: block;
}

.glossary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 12px;
}

.glossary-item {
  padding: 12px;
  border: 1px solid #d8e1df;
  border-radius: 10px;
  background: #f8fafc;
}

.glossary-item b {
  color: #183b56;
}

.guide-warning {
  color: #8b581d;
  background: #fff8e8;
}

@media (max-width: 600px) {
  .glossary-grid {
    grid-template-columns: 1fr;
  }
}
</style>
